import React, { useEffect } from 'react'
import "./Assets/main.css"
import { Route, Routes } from 'react-router-dom';
import FirstBasicSections from './components/FirstBasicSections/FirstBasicSections';
import FixedHeader from './components/Header/FixedHeader';
import Services from './Pages/Services/Services';
import NewOferta from './Pages/Services/NewOferta';
import Branchs from "./Pages/Branchs/Branchs"
import Aos from "aos"
import "aos/dist/aos.css"
import Manual from './Pages/Manual/Manual';
function App() {
  useEffect(() => {
    Aos.init({ duration: 600 })
  }, [])
  return (
    <>
      <FixedHeader />
      <Routes>
        <Route path='/' element={<FirstBasicSections />} />
        <Route path='/services' element={<Services />} />
        <Route path='/user-agreement' element={<NewOferta />} />
        <Route path='/branchs' element={<Branchs />} />
        <Route path='/manual' element={<Manual />} />
      </Routes>

    </>
  );
}

export default App;
